export default function() {
    const homeBannerVideoWrapper = document.getElementById('home-banner-video');

    if (homeBannerVideoWrapper) {
        const videoSources = {
            mp4: '/images/hero-video.mp4',
            webm: '/images/hero-video.webm'
        };
    
        const videoEl = document.createElement('video');
        videoEl.muted = true;
        videoEl.setAttribute('playsinline', '');
        videoEl.setAttribute('loop', '');
        videoEl.setAttribute('autoplay', '');
        videoEl.className = 'embed-responsive-item';
        videoEl.textContent = 'Your browser does not support the video tag.';

        var canPlay = false, mpeg4, h264, webm;

        if (videoEl.canPlayType) {
            // Check for MPEG-4 support
            mpeg4 = "" !== videoEl.canPlayType( 'video/mp4; codecs="mp4v.20.8"' );

            // Check for h264 support
            h264 = "" !== ( videoEl.canPlayType( 'video/mp4; codecs="avc1.42E01E"' )
                || videoEl.canPlayType( 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"' ) );

            // Check for Webm support
            webm = "" !== videoEl.canPlayType( 'video/webm; codecs="vp8, vorbis"' );
        }

        if (h264 || mpeg4) {
            videoEl.src = videoSources.mp4;
            canPlay = true;
        } else if (webm) {
            videoEl.src = videoSources.webm;
            canPlay = true;
        }

        if (canPlay) {
            homeBannerVideoWrapper.appendChild(videoEl);
            document.body.classList.add('hero-video-visible');
            window.setTimeout(function() {
                document.body.classList.add('hero-image-hidden');
            }, 200)
            videoEl.play();
        }
    }
}